import { namedTimeZonePlugin } from "@appComponents/helpers/full_calendar_named_time_zone"

// FullCalendar (core, plugins, French locale) and Moment, loaded when a practitioner calendar
// connects so they stay out of the bundle every page downloads (each import() is its own file).
let calendarModules

export function loadFullCalendar () {
  calendarModules ||= Promise.all([
    import("@fullcalendar/core"),
    import("@fullcalendar/core/internal"),
    import("@fullcalendar/daygrid"),
    import("@fullcalendar/timegrid"),
    import("@fullcalendar/list"),
    import("@fullcalendar/interaction"),
    import("@fullcalendar/core/locales/fr"),
    import("moment")
  ]).then(([core, internal, dayGrid, timeGrid, list, interaction, fr, moment]) => ({
    Calendar: core.Calendar,
    timeZonePlugin: namedTimeZonePlugin({ createPlugin: core.createPlugin, NamedTimeZoneImpl: internal.NamedTimeZoneImpl }),
    dayGridPlugin: dayGrid.default,
    timeGridPlugin: timeGrid.default,
    listPlugin: list.default,
    interactionPlugin: interaction.default,
    frLocale: fr.default,
    moment: moment.default
  }))
  return calendarModules
}
